module.exports = __webpack_public_path__ + "static/img/login_bg.fa39765.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_bg.jpg
// module id = npKG
// module chunks = 2